import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconTeam = (props) => {
  props = Object.assign({viewBox: '0 0 36 36'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M26.2,8h-5.5l-0.2,0.5c-0.4,1.1-1.4,1.9-2.6,1.9c-1.2,0-2.2-0.8-2.6-1.9L15.3,8H9.8l-6.7,6.7l5.7,5.7l1.8-1.8V28h14.9v-9.3
		l1.7,1.7l5.7-5.7L26.2,8z M24.2,15.5v11.2H12V15.3l-3.2,3.2L5,14.7l5.4-5.4h4c0.7,1.4,2.1,2.3,3.7,2.3c1.6,0,3-0.9,3.7-2.3h4
		l5.4,5.4l-3.8,3.8L24.2,15.5z"/>
        <polygon points="14.4,15.5 14.7,16.6 15.6,16.1 15.6,20.4 16.9,20.4 16.9,14.8 15.9,14.8 	"/>
        <path d="M21.2,14.8h-1.4l-2.2,3.4v0.9h2.4v1.3h1.3v-1.3h0.7V18h-0.7V14.8z M19,18l0.8-1.2c0.1-0.1,0.1-0.2,0.1-0.3
		c0,0.1,0,0.1,0,0.2V18H19z"/>
      </g>
    </SvgIcon>
  );
};

IconTeam.displayName = 'IconTeam';
IconTeam.muiName = 'SvgIcon';

export default IconTeam;



// WEBPACK FOOTER //
// ./src/components/Icons/IconTeam.js